import { urlManger } from "@/url/common";
import { EntityUrl } from "@intasect/platform-core";
export const url_event: EntityUrl = {
  
    get page() {
        return `${urlManger.getServiceUrl("user")}/cmb/event/findCmbEventPage` ;
    },
   
};
